import ApiCollection from '@widesk-core/models/ApiCollection';
import ApiModel      from '@widesk-core/models/ApiModel';
import FileModel     from './services/shop/file/FileModel';

export const fetchImageFor = async <M extends ApiModel>(
	models: M[],
	propertyName: string & keyof M,
	fileReference: FileModel['_tsFilters']['typeSource.type.reference'],
) => {
	// Ne fetch que les models pour lesquel l'image n'a pas déjà été récupérée
	const modelUrns = models.filter(m => !m[propertyName]).map(p => p.urn);

	if (!modelUrns.length) return;

	const fileCollection = new ApiCollection(FileModel);

	await fileCollection
		.setFilter('typeSource.source.entityUrn', modelUrns)
		.setFilter('typeSource.type.reference', fileReference)
		.list();

	await fileCollection.whenIsLoaded(f => f.typeSource.source);

	await Promise.all(models.map(async model => {
		const file = fileCollection.find(f => f.typeSource.source.entityUrn === model.urn);
		const image = file?.downloadPath || '';

		if (image) {
			model.set(propertyName, image);
		}
		if (file) {
			model.set('imageName', file.name);
		}
	}));
}